import { createI18n } from 'vue-i18n';
import { createDateFormatter } from './date-formatter';
import messages from './custom-messages';

const locale = 'nl-NL';

const translations = createI18n({
  locale,
  legacy: true,
  fallbackLocale: 'nl-NL',
  messages,
});

export const dateFormatter = createDateFormatter(locale);

export default translations;
